import { useEffect, useState } from "react";
import useTestExpenditureData from "../testdata/expenditure/testexpenditurestore";



const testLookup = {
    states: [
        { label: "Alabama", value: 45 },
        { label: "Alaska", value: 23 },
        { label: "Arizona", value: 76 },
        { label: "Arkansas", value: 12 },
        { label: "California", value: 88 },
        { label: "Colorado", value: 34 },
        { label: "Connecticut", value: 67 },
        { label: "Delaware", value: 29 },
        { label: "Florida", value: 92 },
        { label: "Georgia", value: 55 },
        { label: "Hawaii", value: 19 },
        { label: "Idaho", value: 80 },
        { label: "Illinois", value: 42 },
        { label: "Indiana", value: 75 },
        { label: "Iowa", value: 31 },
        { label: "Kansas", value: 66 },
        { label: "Kentucky", value: 54 },
        { label: "Louisiana", value: 21 },
        { label: "Maine", value: 98 },
        { label: "Maryland", value: 40 },
        { label: "Massachusetts", value: 83 },
        { label: "Michigan", value: 27 },
        { label: "Minnesota", value: 72 },
        { label: "Mississippi", value: 11 },
        { label: "Missouri", value: 36 },
        { label: "Montana", value: 61 },
        { label: "Nebraska", value: 91 },
        { label: "Nevada", value: 50 },
        { label: "New Hampshire", value: 78 },
        { label: "New Jersey", value: 39 },
        { label: "New Mexico", value: 84 },
        { label: "New York", value: 95 },
        { label: "North Carolina", value: 28 },
        { label: "North Dakota", value: 70 },
        { label: "Ohio", value: 49 },
        { label: "Oklahoma", value: 85 },
        { label: "Oregon", value: 18 },
        { label: "Pennsylvania", value: 63 },
        { label: "Rhode Island", value: 99 },
        { label: "South Carolina", value: 32 },
        { label: "South Dakota", value: 56 },
        { label: "Tennessee", value: 77 },
        { label: "Texas", value: 90 },
        { label: "Utah", value: 41 },
        { label: "Vermont", value: 58 },
        { label: "Virginia", value: 25 },
        { label: "Washington", value: 73 },
        { label: "West Virginia", value: 17 },
        { label: "Wisconsin", value: 64 },
        { label: "Wyoming", value: 37 }
    ],
    categoryTypes: [
        { value: 4, label: "ELECTRONICS-OTHER" },
        { value: 5, label: "ELECTRONICS-TV" },
        { value: 6, label: "FOOD" },
        { value: 7, label: "FURNITURE-OTHER" },
        { value: 8, label: "HOUSEWARE-BATHROOM" },
        { value: 9, label: "HOUSEWARE-BEDROOM" },
        { value: 10, label: "HOUSEWARE-KITCHEN" },
        { value: 11, label: "HOUSEWARE-LIVING ROOM" },
        { value: 12, label: "HOUSEWARE-NON SPECIFIC" },
        { value: 13, label: "MEDICAL ALERT SYSTEM" },
        { value: 14, label: "MEDICAL-EQUIPMENT" },
        { value: 15, label: "MEDICAL-SUPPLIES" },
        { value: 16, label: "MEDICAL-MEDICATIONS" },
        { value: 17, label: "PERSONAL ITEMS" },
        { value: 18, label: "PEST CONTROL" },
        { value: 19, label: "RENT" },
        { value: 20, label: "SECURITY DEPOSIT-OTHER" },
        { value: 21, label: "SECURITY DEPOSIT-RENT" },
        { value: 22, label: "SECURITY DEPOSIT-UTILITIES" },
        { value: 23, label: "TRANSPORTATION" },
        { value: 24, label: "OTHER" },
        { value: 25, label: "FURNITURE-RECLINERS" },
        { value: 26, label: "FURNITURE-BED/MATRESS" },
        { value: 27, label: "FURNITURE-TABLE" },
        { value: 28, label: "FURNITURE-CHEST" },
        { value: 29, label: "FURNITURE-COUCH/LOVE SEAT" },
        { value: 30, label: "SECURITY DEPOSIT-CABLE" },
        { value: 31, label: "NO RECEIPT" },
        { value: 32, label: "UNKNOWN" },
        { value: 33, label: "SALES TAX" },
        { value: 34, label: "SMALL TOOLS" },
        { value: 35, label: "FLASHLIGHTS / BATTERIES / CHARGERS" },
        { value: 36, label: "HOUSEHOLD OFFICE SUPPLIES (PENS, PENCIL, ETC.)" },
        { value: 37, label: "STORAGE CONTAINERS" },
        { value: 38, label: "CARD PROCESSING FEES" },
        { value: 39, label: "SHIPPING / DELIVERY / SET-UP FEES" },
        { value: 40, label: "TOYS" },
        { value: 41, label: "COURT DOCUMENTS" },
        { value: 42, label: "APPLICATION FEES" }
    ],
    checkTypes: [
        { value: 1, label: "UK" },
        { value: 2, label: "KHC" },
        { value: 3, label: "Housing" },
        { value: 4, label: "N/A" }
    ],
    expenditureTypes: [
        { value: 1, label: "ProCard" },
        { value: 2, label: "Check" },
        { value: 3, label: "Refund" }
    ],
    expenseTypes: [
        { value: 1, label: "Home Modification" },
        { value: 2, label: "Supplemental Service" }
    ],
    flagCaTypes: [
        { value: 1, label: "None" },
        { value: 2, label: "Staff Training/Education" },
        { value: 3, label: "Staff Personnel Issue" },
        { value: 4, label: "Policy Issue" }
    ],
    flagStatusTypes: [
        { value: 1, label: "N/A" },
        { value: 2, label: "Approved" },
        { value: 3, label: "Disapproved" }
    ]
};


const testAdmin = {
    mfp: [
        { value: "dsfadsf", label: "Jay Bruce" },
        { value: "jgfdtdh", label: "Adam Dunn" },
        { value: "kutv", label: "Ryan Freel" },
        { value: "sergh", label: "Jason LaRue" },
        { value: "vbghjj", label: "Aaron Harang" },
        { value: "sdfghj", label: "Bronson Arroyo" },
        { value: "iouytr", label: "Ken Griffey Jr." },
    ],
    cop: [
        { value: "kjyw", label: "Bret Boone" },
        { value: "tyer", label: "Ichiro Suzuki" },
        { value: "opolj", label: "Felix Hernandez" },
        { value: "bqwea", label: "Jaime Moyer" },
        { value: "dtyui", label: "Edgar Martinez" },
        { value: "jjkl", label: "Adrian Beltre" },
        { value: "aaaaaaa", label: "Raul Ibanez" },
    ]
}



const useExpenditureWorksheetFetch = (applicationId) => {


    const _responseDataTypes = {
        proCard: "PROCARD",
        check: "CHECK",
        refund: "REFUND",
        all: "ALL"
    };

    const testData = useTestExpenditureData();

    const [refreshProCard, setRefreshProCard] = useState(false);
    const [refreshChecks, setRefreshChecks] = useState(false);
    const [refreshRefunds, setRefreshRefunds] = useState(false);

    const [proCard, setProCard] = useState([]);
    const [proCardLoading, setProCardLoading] = useState(false);

    const [checks, setChecks] = useState([]);
    const [checksLoading, setChecksLoading] = useState(false);

    const [refunds, setRefunds] = useState([]);
    const [refundsLoading, setRefundsLoading] = useState(false);


    const [lookup, setLookup] = useState(testLookup);
    const [lookupLoading, setLookupLoading] = useState(false);

    const [admin, setAdmin] = useState(testAdmin);
    const [adminLoading, setAdminLoading] = useState(false);


    const fetchLookupData = async () => {

    };

    const fetchAdminData = async () => {

    }


    // Assumes API endpoint is the same for all items with a parameter indicating what to return

    const fetchExpenditureWorksheet = async (dataTypeKey) => {





        switch (dataTypeKey) {
            case _responseDataTypes.proCard:
                setProCard(testData.proCards);
                break;
            case _responseDataTypes.check:
                setChecks(testData.checks);
                break;
            case _responseDataTypes.refund:
                setRefunds(testData.refunds);
                break;
            case _responseDataTypes.all:
                setProCard(testData.proCards);
                setChecks(testData.checks);
                setRefunds(testData.refunds);
                break;
            default:
                throw new Error("Invalid data type");
        }
    };


    // fetch lookup data
    useEffect(() => {

    }, []);

    // fetch admin data
    useEffect(() => {

    }, []);


    // fetch expenditure worksheet
    useEffect(() => {
        fetchExpenditureWorksheet(_responseDataTypes.all);
    }, []);


    // refresh proCard
    useEffect(() => {
        if (refreshProCard) {
            fetchExpenditureWorksheet(_responseDataTypes.proCard).then(() => setRefreshProCard(false));
        }
    }, [refreshProCard]);

    // refresh checks
    useEffect(() => {
        if (refreshChecks) {
            fetchExpenditureWorksheet(_responseDataTypes.check).then(() => setRefreshChecks(false));
        }
    }, [refreshChecks]);

    // refresh refunds
    useEffect(() => {
        if (refreshRefunds) {
            fetchExpenditureWorksheet(_responseDataTypes.refund).then(() => setRefreshRefunds(false));
        }
    }, [refreshRefunds]);



    return {
        setRefreshProCard,
        setRefreshChecks,
        setRefreshRefunds,
        data: {
            proCard,
            checks,
            refunds
        },
        lookupData: lookup,
        adminData: admin,
        amounts: {
            proCard: {
                total: proCard.map(x => x.amount).reduce((acc, next) => acc + next, 0),
                homeModification: proCard.filter(x => x.expenditureTypeId == "1").map(x => x.amount).reduce((acc, next) => acc + next, 0),
                supplementalService: proCard.filter(x => x.expenditureTypeId == "2").map(x => x.amount).reduce((acc, next) => acc + next, 0)
            },
            checks: {
                total: checks.map(x => x.amount).reduce((acc, next) => acc + next, 0),
                homeModification: checks.filter(x => x.expenditureTypeId == "1").map(x => x.amount).reduce((acc, next) => acc + next, 0),
                supplementalService: checks.filter(x => x.expenditureTypeId == "2").map(x => x.amount).reduce((acc, next) => acc + next, 0)
            },
            refunds: {
                total: refunds.map(x => x.amount).reduce((acc, next) => acc + next, 0)
            },
        },
        loading: {
            proCard: proCardLoading,
            checks: checksLoading,
            refunds: refundsLoading,
            lookup: lookupLoading,
            admin: adminLoading
        }
    }
};


export default useExpenditureWorksheetFetch;

